import React from 'react';
import { Timeline } from 'react-twitter-widgets';

const TwitterSection = ({ accountName }) => {
    return (
        <div className="TwitterSection">
            <Timeline
                dataSource={{
                    sourceType: 'profile',
                    screenName: accountName
                }}
                options={{
                    username: accountName
                }}
            />
        </div>
    );
};

export default TwitterSection;



// WEBPACK FOOTER //
// ./src/components/TwitterSection.js